import { useEffect } from 'react'
import shortid from 'shortid'

export default function useFa2 (Fa2Instance, nodes, edges, manager, lerp, stats, running) {
  const { FA2params, barnesHutThetaRef, maxDRef } = stats

  useEffect(() => {
    const currenIterationId = Fa2Instance.iterationId
    let isStopped = false

    function run () {
      Fa2Instance.run(
        {
          ...FA2params,
          barnesHutTheta: barnesHutThetaRef.current,
          maxD: maxDRef.current
        },
        currenIterationId,
        nodes.length,
        edges.length,
        lerp.to,
        manager.fa2,

        (result) => {
          if (!isStopped && result.iterationId === currenIterationId) {
            lerp.setEdgePositionTo(result.PositionsArray)
            manager.fa2.convergences.set(result.ConvergencesArray)

            barnesHutThetaRef.current = Math.max(
              barnesHutThetaRef.current - 0.01,
              0.6
            )
            maxDRef.current = Math.max(
              maxDRef.current - (maxDRef.current * 0.03),
              1
            )

            run()
          }
        }
      )
    }

    if (running) run()

    return () => {
      isStopped = true
      Fa2Instance.iterationId = shortid()
    }
  }, [running, lerp, Fa2Instance, nodes, edges, FA2params, manager, barnesHutThetaRef, maxDRef])
}
